var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriaOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 386,
    viewBox: "0 0 706 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4066_5357)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.697,
    cy: 193.014,
    rx: 260.5,
    ry: 92.5,
    transform: "rotate(-7.80374 352.697 193.014)",
    fill: "url(#paint0_linear_4066_5357)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4066_5357",
    x: 0.298828,
    y: 0.755249,
    width: 704.797,
    height: 384.518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 47,
    result: "effect1_foregroundBlur_4066_5357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4066_5357",
    x1: 364.7,
    y1: 107.231,
    x2: 439.695,
    y2: 264.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.112499,
    stopColor: "#FF6A3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE6A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriaOrange);
export default __webpack_public_path__ + "static/media/tria-orange.ae40f6b339813ed243e770f6cb44f723.svg";
export { ForwardRef as ReactComponent };